import React from "react";
import { useAccess } from "../hooks/useAccess";
export default function Can({ permission, children, readOnly = false }: { permission: string; children: React.ReactNode; readOnly?: boolean }) {
  if (useAccess().can(permission)) return <>{children}</>;
  if (!readOnly || !React.isValidElement<Record<string, unknown>>(children)) return null;
  return React.cloneElement(children, {
    ...(children.type === "button" || children.type === "select" ? { disabled: true } : {}),
    onClick: undefined, onChange: undefined, "aria-disabled": true,
  });
}
